export default __webpack_public_path__ + "static/media/sra.28dd1a61.png";